<template>
    <div id="app">
        <!-- 头部 -->
        <headerC v-if="showHeader"></headerC>

        <router-view />

        <footerC v-if="showFooter"></footerC>
    </div>
</template>

<script>
import { getProductListApi } from "@/api/index";

import headerC from "@/components/share/header";
import footerC from "@/components/share/footer";

export default {
    name: "",

    data() {
        return {
            showHeader: false,
            showFooter: false
        };
    },

    watch: {
        $route: {
            handler: function(val) {
                this.showHeader = val.meta.showHeader;
                this.showFooter = val.meta.showFooter;
            },
            deep: true,
            immediate: true
        }
    },

    methods: {
        //获取所有产品
        getProductList() {
            getProductListApi().then(res => {
                if (res.data.code != 200) {
                    alert(res.data.msg);
                    return;
                }

                this.$store.commit("setState", {
                    productList: res.data.data
                });
            });
        }
    },

    components: {
        headerC,
        footerC
    },

    created() {
        this.getProductList();
    },

    mounted() {}
};
</script>

<style lang="less">
@mimoColor: #813f44;

.highlight {
    color: @mimoColor;
    font-weight: bold;
}

@media screen and (min-width: 460px) {
     div::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
    }

     div::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: #9e9e9e;
    }

     div::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        background: #ededed;
    }
}

#app {
    color: #333;
    -webkit-tap-highlight-color: transparent;
}
</style>
